export default {
    'pointList.kc': 'Inventory on hand',
    'pointList.lgkc': 'Refrigerator inventory',
    'pointList.tlkc': 'Seasoning inventory'
}
